import type { FaireProductEntity } from "../../entity_types/product";

export const p_uchkmjb828: FaireProductEntity = {
  token: "p_uchkmjb828",
  type: "product",
  name: "Ionic Liquid Silica",
  brandToken: "b_n34zp8ykn9",
  brandName: "Eidon Ionic Minerals",
  imageUrl:
    "https://cdn.faire.com/fastly/720b9f73be2c6422939dce47013968e31f3c5d51c5a98fad44a6c1049daa0d55.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7c130162ddbe254fef4b03a5241404082c4f06235633ba13b5c71853be2a602.jpeg",
    "https://cdn.faire.com/fastly/0c21b1be365860adefb64af93d5614934e9bcdcf18136cc1c487328b1cb1fdcc.jpeg",
    "https://cdn.faire.com/fastly/9dd30fa26cf1a9056280cb3a4cec3d321b05d12fcb1556f0e042c162d9dcce67.jpeg",
    "https://cdn.faire.com/fastly/9a22c2decd901b0e0e032da648286aeaa17201834ab8de794194fe6076ea5c13.jpeg",
    "https://cdn.faire.com/fastly/43ca5a1daa2845d8c1342f454b7fdcacbb7d2d968bd642066b7b0937adb48682.png",
  ],
  priceDollars: 16.63,
  description:
    "Silica is essential in collagen formation and connective tissue strength. Collagen is the tough fibrous material which holds our cells together and is the major component of everything from our bones to our skin. Silica deficiencies can occur when eating a diet of refined grains. Historically, the primary source of dietary Silica was the outside husks of grains. With the industrial revolution and the invention of the combine (a machine used to harvest grain), man for the first time could automatically remove grain husks. So, rather than being the staff of life, bread had the first of many essential mineral nutrients removed.\n\nThe two primary functions of Silica Supplement based on research and experience are:\n- Building and maintaining healthy collagen levels throughout the body\n- Managing calcium usage and storage within the body\n\nSilica supplement can help to support: Collagen production, Healthy cartilage, Joint function, hair/skin/nails.\n\nEasy on the stomach. Safe for all ages. ",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:25.080Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
